// Dependencies
import styled, { css, keyframes } from 'styled-components'

export const ButtonWrapper = styled.button<{
  variant: 'primary' | 'dark'
  isFullyAdaptative?: boolean
  size: 'large' | 'small'
  disabled?: boolean
}>`
  border-radius: 8px;
  padding: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  transition: all ease 0.2s;

  cursor: pointer;

  ${({ size }) =>
    size === 'small' &&
    css`
      height: 32px;
    `}

  ${({ size }) =>
    size === 'large' &&
    css`
      height: 48px;
    `}

  ${({ isFullyAdaptative }) =>
    isFullyAdaptative &&
    css`
      width: 100%;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
    `}

  ${({ variant }) =>
    variant === 'primary' &&
    css`
      background: #df1d3d;
      border: 1px solid #df1d3d;
      color: #fff;
    `}

    ${({ variant }) =>
    variant === 'dark' &&
    css`
      background: #25272d;
      border: 1px solid #25272d;
      color: #fff;
    `}
`

export const Label = styled.p`
  font-family: 'Fira Sans';
  font-style: normal;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
`

const ellipsis1 = keyframes`
   0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`

const ellipsis2 = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(12px, 0);
  }
`

const ellipsis3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`

export const Loader = styled.div`
  display: flex;
  position: absolute;

  > div {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 13px;

    > div {
      position: absolute;
      top: 3.25px;
      width: 6.5px;
      height: 6.5px;
      border-radius: 50%;
      background: #fff;
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    > div:nth-child(1) {
      left: 4px;
      animation: ${ellipsis1} 0.6s infinite;
    }

    > div:nth-child(2) {
      left: 4px;
      animation: ${ellipsis2} 0.6s infinite;
    }

    > div:nth-child(3) {
      left: 16px;
      animation: ${ellipsis2} 0.6s infinite;
    }

    > div:nth-child(4) {
      left: 28px;
      animation: ${ellipsis3} 0.6s infinite;
    }
  }
`
